module.exports = __webpack_public_path__ + "static/media/2.d10c7240.JPG";